import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import '../../../App.css';
import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import ScheduleIcon from '@material-ui/icons/Schedule';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import VideoPlayer from 'react-video-js-player';
import works from '../../../images/works.mp4';
import Poster from '../../../images/banner.png';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: '6px 16px'
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main
    }
}));

const HowItWorks = () => {
    const classes = useStyles();

    return (
        <section id="works" className="mt-5">
            <Container>
                <div className="d-flex justify-content-center mb-4">
                    <h1 className="heading" data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
                        gutterBottom>
                        <span>H</span>
                        <span>O</span>
                        <span>W</span>
                        <span className="space">{""}</span>
                        <span>I</span>
                        <span>T</span>
                        <span className="space">{""}</span>
                        <span>W</span>
                        <span>O</span>
                        <span>R </span>
                        <span>R </span>
                        <span>K</span>
                        <span>S </span>
                    </h1>
                </div>
                <Row>
                    <Col md={6} data-aos="fade-right" data-aos-easing="linear"
                        data-aos-duration="1500">
                        <Timeline align="alternate">
                            <TimelineItem>
                                <TimelineSeparator>
                                    <TimelineDot color="secondary">
                                        <AssignmentTurnedInIcon />
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Paper elevation={3} className={classes.paper}>
                                        <Typography variant="h6" component="h1">
                                            Select Course
                                        </Typography>
                                    </Paper>
                                </TimelineContent>
                            </TimelineItem>
                            <TimelineItem>
                                <TimelineSeparator>
                                    <TimelineDot color="secondary">
                                        <LocalMallIcon />
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Paper elevation={3} className={classes.paper}>
                                        <Typography variant="h6" component="h1">
                                            Place Order
                                        </Typography>
                                    </Paper>
                                </TimelineContent>
                            </TimelineItem>
                            <TimelineItem>
                                <TimelineSeparator>
                                    <TimelineDot color="secondary">
                                        <ScheduleIcon />
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Paper elevation={3} className={classes.paper}>
                                        <Typography variant="h6" component="h1">
                                            Start Class
                                        </Typography>
                                    </Paper>
                                </TimelineContent>
                            </TimelineItem>
                            <TimelineItem>
                                <TimelineSeparator>
                                    <TimelineDot color="secondary">
                                        <AssignmentIcon />
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Paper elevation={3} className={classes.paper}>
                                        <Typography variant="h6" component="h1">
                                            Submit Homework
                                        </Typography>
                                    </Paper>
                                </TimelineContent>
                            </TimelineItem>
                            <TimelineItem>
                                <TimelineSeparator>
                                    <TimelineDot color="secondary">
                                        <AssignmentIndIcon />
                                    </TimelineDot>
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Paper elevation={3} className={classes.paper}>
                                        <Typography variant="h6" component="h1">
                                            Practice & Practice
                                        </Typography>
                                    </Paper>
                                </TimelineContent>
                            </TimelineItem>
                            <TimelineItem>
                                <TimelineSeparator>
                                    <TimelineDot color="secondary">
                                        <LiveHelpIcon />
                                    </TimelineDot>
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Paper elevation={3} className={classes.paper}>
                                        <Typography variant="h6" component="h1">
                                            Ask us for Support
                                        </Typography>
                                    </Paper>
                                </TimelineContent>
                            </TimelineItem>
                        </Timeline>
                    </Col>

                    <Col md={6} className="d-flex justify-content-center" data-aos="fade-left" data-aos-easing="linear"
                        data-aos-duration="1500">
                        <VideoPlayer src={works} poster={Poster} width="720" height="360" className="mt-4" />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default HowItWorks;
